import { render, staticRenderFns } from "./FarmSetup.vue?vue&type=template&id=fda89588&scoped=true&"
import script from "./FarmSetup.vue?vue&type=script&lang=js&"
export * from "./FarmSetup.vue?vue&type=script&lang=js&"
import style0 from "./FarmSetup.vue?vue&type=style&index=0&id=fda89588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda89588",
  null
  
)

export default component.exports